import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";

import MantenimientoItfz from "./MantenimientoIntfz.jsx";
import { Repartidor_Agregar, Repartidor_Modificar, Repartidor_Detalle, Obtener_Sucursales_Lista } from "../../../request/MantenimientosRequest";
import { SiteRutas } from "../../../request/RutasConfig";
import { Notificacion } from "../../../components/Util/Notificacion/Notificacion";

class RepartidorMantenimiento extends PureComponent {
    _isMounted = false;

    state = {
        Datos: {
            Emp_Id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "none",
                    label: ""
                }
            },
            Repartidor_Id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "unset",
                    label: "Id:"
                }
            },
            CC_Id: {
                value: 0,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: ""
                }
            },
            Nombre: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Nombre:",
                    maxLength: 35
                }
            },
            Estatus: {
                value: false,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Disponible:"
                }
            },
            Suc_Id: {
                value: 0,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Sucursal:"
                }
            },
        },
        titulo: "",
        listaSucursales: [],
        selectedSucursal: null,
        menuId: 0,
        CadenaId: 0
    };

    volverAtras = () => {
        let menuId = this.state.menuId;

        this.props.history.push({
            pathname: `${SiteRutas.Repartidor}`,
            state: { menuId: menuId },
        });
    };

    onChangeInput = (e) => {
        const { name, value } = e.target;

        let newAttributes = this.state.Datos[name].attributes;

        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes }
        });
        this.setState({ Datos });
    };

    validarDatos = () => {
        const Datos = this.state.Datos;
        let selectedSucursal = this.state.selectedSucursal;

        if (!Datos.Nombre.value.trim()) {
            Notificacion.error("Error: Debe ingresar el dato: Nombre");
            return false;
        }

        if (Datos.Nombre.value.trim().length > 35) {
            Notificacion.error("Error: Debe ingresar máximo 35 caracteres");
            return false;
        }

        if (selectedSucursal.value == 0) {
            Notificacion.error("Error: Debe seleccionar el dato: Sucursal");
            return false;
        }

        return true;
    };

    ingresarDatos = async () => {
        let Datos = { ...this.state.Datos };

        if (this.validarDatos()) {
            const token = this.props.token;
            const empresa = this.props.empresa.Id;
            const selectedSucursal = this.state.selectedSucursal;
            const Estatus = Datos.Estatus.value ? "D" : "I";

            let resultado = null;

            if (selectedSucursal.value > 0) {
                if (Datos.Repartidor_Id.value > 0) {
                    resultado = await Repartidor_Modificar(token, empresa, Datos.CC_Id.value, Datos.Repartidor_Id.value, Datos.Nombre.value, Estatus, selectedSucursal.value);
                } else {
                    resultado = await Repartidor_Agregar(token, empresa, Datos.CC_Id.value, Datos.Repartidor_Id.value, Datos.Nombre.value, Estatus, selectedSucursal.value);
                }

                if (resultado.Exitoso) {
                    if (Datos.Repartidor_Id.value > 0) {
                        Notificacion.success("Se actualizó la información con éxito ");
                    } else {
                        Notificacion.success("Se almacenó la información con éxito");

                        let Id = resultado.Mensaje.split(":")[1];
                        Datos.Repartidor_Id.value = Id;
                        this._isMounted && this.setState({ Datos });
                    }
                } else {
                    Notificacion.error("Error: " + resultado.Mensaje);
                }
            }
        }
    };

    onSelectChanged = async (event) => {
        const { name, value } = event.target;

        let newAttributes = this.state.Datos[name].attributes;
        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });

        this._isMounted && this.setState({ Datos });
    };

    onhandleSelectedOption = (selectedSucursal) => {
        this._isMounted && this.setState({ selectedSucursal });
    };

    handleCheckBox = (event) => {
        const { name, checked } = event.target;
        let newAttributes = this.state.Datos[name].attributes;

        let Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: checked, attributes: newAttributes },
        });

        this._isMounted && this.setState({ Datos });
    };

    componentDidMount = async () => {
        this._isMounted = true;

        let menuId = 0;
        let CadenaId = 0;

        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        let Datos = { ...this.state.Datos };
        let listaSucursales = [];
        let selectedSucursal = null;

        let Id = this.props.match.params.id;
        let CC_id = this.props.match.params.CC_id;
        let empresa = this.props.empresa.Id;
        let token = this.props.token;

        let titulo = Id > 0 ? "Modificar Repartidor" : "Nuevo Repartidor";

        Datos.Emp_Id.value = empresa;
        Datos.CC_Id.value = CC_id;

        const response = await Obtener_Sucursales_Lista(token, empresa, CadenaId);
        if (response.Exitoso) {
            listaSucursales = [{ value: 0, label: "Seleccione una opción" }];

            response.Datos.forEach((item) => {
                listaSucursales.push({ value: item.Id, label: item.Nombre });
            });

            selectedSucursal = listaSucursales[0];
        } else {
            Notificacion.error(response.Mensaje);
        }

        if (Id > 0) {

            const DatosRepartidor = await Repartidor_Detalle(token, empresa, CC_id, Id);
            if (DatosRepartidor.Exitoso) {
                let resultado = listaSucursales.filter(item => item.value == DatosRepartidor.Datos.Suc_Id);

                if (resultado.length > 0) {
                    selectedSucursal = resultado[0];
                }

                Datos.Repartidor_Id.value = DatosRepartidor.Datos.Repartidor_Id;
                Datos.Suc_Id.value = DatosRepartidor.Datos.Suc_Id;
                Datos.Nombre.value = DatosRepartidor.Datos.Nombre;
                Datos.Estatus.value = DatosRepartidor.Datos.Estatus === "D";
            } else {
                Notificacion.error(DatosZona.Mensaje);
            }
        }

        this._isMounted && this.setState({ titulo, Datos, listaSucursales, selectedSucursal, menuId, CadenaId });
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { titulo, Datos, selectedSucursal, listaSucursales } = this.state;

        return (
            <div className="main">
                <Container>
                    <Row>
                        <Col>
                            <h1>{titulo}</h1>
                        </Col>
                    </Row>
                    <div className="content-bg">
                        <MantenimientoItfz
                            Datos={Datos}
                            volverAtras={this.volverAtras}
                            ingresarDatos={this.ingresarDatos}
                            onChangeInput={this.onChangeInput}
                            onSelectChanged={this.onSelectChanged}
                            selectedSucursal={selectedSucursal}
                            listaSucursales={listaSucursales}
                            onhandleSelectedOption={this.onhandleSelectedOption}
                            handleCheckBox={this.handleCheckBox}
                        />
                    </div>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
    };
};

export default connect(mapStateToProps)(
    withRouter(memo(RepartidorMantenimiento))
);
